import 'tailwindcss/dist/base.css'
import React from 'react'
import localStateClient from './src/client'
import { ApolloProvider } from '@apollo/react-hooks'

// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={localStateClient}>{element}</ApolloProvider>
)
